import { render, staticRenderFns } from "./yi.vue?vue&type=template&id=09cae603&scoped=true&"
import script from "./yi.vue?vue&type=script&lang=js&"
export * from "./yi.vue?vue&type=script&lang=js&"
import style0 from "./yi.vue?vue&type=style&index=0&id=09cae603&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cae603",
  null
  
)

export default component.exports